module.exports = {
      id: "google-plus-usage",
      viewBox: "0 0 64 41",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#google-plus",
      toString: function () {
        return this.url;
      }
    }